module.exports = __webpack_public_path__ + "static/img/detailImgwem.e8ac92a.png";


//////////////////
// WEBPACK FOOTER
// ./src/project/integralMallProject/images/detailImgwem.png
// module id = hwAp
// module chunks = 6